export default __webpack_public_path__ + "static/media/appstore.58ce6252.svg";